import TabSwitch from './TabSwitch';

export default TabSwitch;